import React from 'react';
import { Box, Typography, IconButton, Link as MuiLink } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import XIcon from '@mui/icons-material/X';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import SectionContainer from './SectionContainer';
import { footerColumns, socialLinks } from './content';

const socialIcons = {
  Facebook: FacebookIcon,
  X: XIcon,
  LinkedIn: LinkedInIcon,
  Instagram: InstagramIcon,
};

const legalLinks = ['Privacy Policy', 'Terms of Service'];

const Footer = () => (
  <Box
    component="footer"
    sx={{
      bgcolor: (theme) => (theme.palette.mode === 'dark' ? '#0b0e17' : '#0F1B3D'),
      color: 'rgba(255,255,255,0.85)',
      pt: { xs: 6, md: 8 },
      pb: 3,
    }}
  >
    <SectionContainer>
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1.4fr 1fr 1fr 1fr' }, gap: 5, mb: 6 }}>
        <Box>
          <Box
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              bgcolor: '#fff',
              borderRadius: 999,
              px: 1.25,
              py: 0.75,
              mb: 2,
            }}
          >
            <img src="/logo.svg" alt="Remembr" style={{ height: 24, display: 'block' }} />
          </Box>
          <Typography sx={{ fontSize: 14, color: 'rgba(255,255,255,0.6)', maxWidth: 280, mb: 2.5 }}>
            Never get overcharged twice. The smart platform that helps you manage bills, services and maintenance with ease.
          </Typography>
          <Typography sx={{ fontSize: 13, color: 'rgba(255,255,255,0.55)' }}>
            Built by{' '}
            <MuiLink
              href="https://www.arrayscript.com"
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
              sx={{ color: 'rgba(255,255,255,0.85)', fontWeight: 600 }}
            >
              Arrayscript
            </MuiLink>
          </Typography>
        </Box>

        {footerColumns.map(({ title, links }) => (
          <Box key={title}>
            <Typography sx={{ fontWeight: 700, fontSize: 14, mb: 2, color: '#fff' }}>{title}</Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.2 }}>
              {links.map(({ label, href }) => (
                <MuiLink key={label} href={href} underline="none" sx={{ fontSize: 14, color: 'rgba(255,255,255,0.6)', '&:hover': { color: '#fff' } }}>
                  {label}
                </MuiLink>
              ))}
            </Box>
          </Box>
        ))}

        <Box>
          <Typography sx={{ fontWeight: 700, fontSize: 14, mb: 2, color: '#fff' }}>Connect</Typography>
          <Box sx={{ display: 'flex', gap: 1 }}>
            {socialLinks.map(({ label, href }) => {
              const Icon = socialIcons[label];
              return (
                <IconButton
                  key={label}
                  component="a"
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  size="small"
                  sx={{ color: 'rgba(255,255,255,0.75)', bgcolor: 'rgba(255,255,255,0.06)', '&:hover': { bgcolor: 'rgba(255,255,255,0.14)' } }}
                >
                  <Icon fontSize="small" />
                </IconButton>
              );
            })}
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          borderTop: '1px solid rgba(255,255,255,0.1)',
          pt: 3,
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          gap: 1.5,
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Typography sx={{ fontSize: 13, color: 'rgba(255,255,255,0.5)' }}>
          © {new Date().getFullYear()} Remembr. All rights reserved.
        </Typography>
        <Box sx={{ display: 'flex', gap: 3 }}>
          {legalLinks.map((item) => (
            <MuiLink key={item} href="#" underline="none" sx={{ fontSize: 13, color: 'rgba(255,255,255,0.5)', '&:hover': { color: '#fff' } }}>
              {item}
            </MuiLink>
          ))}
        </Box>
      </Box>
    </SectionContainer>
  </Box>
);

export default Footer;
